import { TrackInfo } from '../../model/track-info';
import { TrackActionResult } from "../../model/track-action-result";
import { RegistratioData } from "../../../../../../shared/model/registration-data";

export class OriginInvestActionV2 {

    public static execute(data: RegistratioData, track: TrackInfo[],
                          edit?: boolean, includeTrack?: () => void): TrackActionResult {
        const id = data.professionalData.originIncome;
        const income: string = data.incomeEquity?.income;
        const patrimony: string = data.incomeEquity?.patrimony;

        const idNotProf = ['11839', '11843', '11838', '11841', '11834', '11837', '12230', '11840'];
        
        const incomeRequired: boolean = data.professionalData?.incomeRequired;
        const patrimonyRequired: boolean = data.professionalData?.patrimonyRequired;

        const filterIdNotProf = idNotProf.find(x => x === id);
        const hasStepIncome = track.findIndex((page: TrackInfo) => page.pageId === 'income-wealthincome') > -1;

        if (incomeRequired && !income
            || incomeRequired && income === '0.00'
            || incomeRequired && income === '0,00'
            || incomeRequired && income === ''
            || patrimonyRequired && patrimony === '0.00'
            || patrimonyRequired && patrimony === '0,00'
            || patrimonyRequired && patrimony === ''
        ) {
            if (data.contaIon && includeTrack) {
                includeTrack();
            }
        }

        if (id === '12229') {
            const trackInfo = new TrackInfo('company-cnpj', ['professional-data', 'company-cnpj']);
            return new TrackActionResult(data, trackInfo);
        }

        if (filterIdNotProf !== undefined) {
            if (!incomeRequired && !edit && hasStepIncome
                || incomeRequired && !income
                || incomeRequired && income === '0.00'
                || incomeRequired && income === '0,00'
                || incomeRequired && income === ''
                || patrimonyRequired && patrimony === '0.00'
                || patrimonyRequired && patrimony === '0,00'
                || patrimonyRequired && patrimony === ''
            ) {
                const trackInfo = new TrackInfo('income-wealthincome', ['income', 'income-wealthincome']);
                return new TrackActionResult(data, trackInfo);
            } else {
                const trackInfo = new TrackInfo('client-data', ['data', 'client-data']);
                return new TrackActionResult(data, trackInfo);
            }
        } else {
            const trackInfo = new TrackInfo('profession', ['professional-data', 'profession']);
            return new TrackActionResult(data, trackInfo);
        }
    }

}
